import { useFirstUsableAnalyticsTab } from "@/hooks/useInteractionAnalyticsTabs";
import { Navigate, useLocation } from "react-router-dom";

export default function InteractionAnalyticsIndexPage() {
  const location = useLocation();
  const firstUsableTab = useFirstUsableAnalyticsTab();

  // The layout redirects index URLs before this renders; this is the fallback
  // if the layout ever stops intercepting. Null while capabilities load.
  if (!firstUsableTab) {
    return null;
  }

  return <Navigate to={`${firstUsableTab}${location.search}`} replace />;
}
